document.addEventListener('DOMContentLoaded', () => {
  const $ = (window as Window & { jQuery?: JQueryStatic }).jQuery;
  if (!$) return;

  $(document).on('click', '.js-action_btn', function () {
    $('.js-action_body', this).toggle();
  });
});
